import { useCallback, useState } from 'react';
import { resetPassword } from '@/api/password-reset';
import { ResetPasswordDto } from '@/interfaces';

export const useResetPassword = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<any>();
  const [error, setError] = useState<unknown>();

  const request = useCallback(async (body: ResetPasswordDto) => {
    setError(null);
    try {
      setLoading(true);
      const data = await resetPassword(body);
      setData(data);
    } catch (err) {
      setError(err);
    }
    setLoading(false);
  }, []);
  return {
    loading,
    data,
    error,
    request,
  };
};
